module.exports = new __parcel__URL__("backspace.b789fe36.mp3").toString();